var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Icon_\\u0421olor",
    "data-name": "\\uD83C\\uDFA8 Icon \\u0421olor",
    d: "M17,16H3a3,3,0,0,1-3-3V3A3,3,0,0,1,3,0H17a3,3,0,0,1,3,3V13A3,3,0,0,1,17,16ZM2,3.25V13a1,1,0,0,0,1,1H17a1,1,0,0,0,1-1V3.25L10.6,8.8a1,1,0,0,1-1.2,0ZM3.667,2,10,6.75,16.333,2Z",
    transform: "translate(2 4)",
    fill: "#505358"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Mail"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mail",
    clipPath: "url(#clip-Mail)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "email",
    transform: "translate(2 4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Icon_\\u0421olor-2",
    "data-name": "\\uD83C\\uDFA8 Icon \\u0421olor",
    d: "M17,16H3a3,3,0,0,1-3-3V3A3,3,0,0,1,3,0H17a3,3,0,0,1,3,3V13A3,3,0,0,1,17,16ZM2,3.25V13a1,1,0,0,0,1,1H17a1,1,0,0,0,1-1V3.25L10.6,8.8a1,1,0,0,1-1.2,0ZM3.667,2,10,6.75,16.333,2Z",
    transform: "translate(0)",
    fill: "#505358"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/Mail.8977e6094d5453219ba7c8aa162215f5.svg";
export { ForwardRef as ReactComponent };